import React from 'react';
import {Checkbox, FormControlLabel, Radio} from '@mui/material';
import {NEW_PLAN_ID} from './builderConstants';

interface SingleSelectorProps {
  mode?: 'single';
  id: string;
  disabled?: boolean;
  fixed?: boolean;
  isSelected: boolean;
  indeterminate?: never;
  handleChange?: () => void;
}

interface MultipleSelectorProps {
  mode: 'multiple';
  id: string;
  disabled?: boolean;
  fixed?: boolean;
  isSelected: boolean;
  indeterminate?: boolean;
  handleChange?: () => void;
}

export type PlanSelectorProps = SingleSelectorProps | MultipleSelectorProps;

export const PlanSelector: React.FC<PlanSelectorProps> = (props) => {
  const {id, disabled = false, fixed = false, isSelected, handleChange} = props;

  if (props.mode === 'multiple') {
    return (
      <Checkbox
        style={{marginLeft: -10, marginRight: 10, backgroundColor: 'white'}}
        disabled={fixed || disabled}
        inputProps={{'aria-label': 'set plan'}}
        checked={isSelected || false}
        indeterminate={props.indeterminate}
        onChange={handleChange}
      />
    );
  }

  return (
    <FormControlLabel
      value={id || NEW_PLAN_ID}
      disabled={disabled || fixed}
      label=""
      checked={isSelected || false}
      control={
        <Radio
          style={{backgroundColor: 'white'}}
          checked={isSelected || false}
          onChange={handleChange}
          inputProps={{'aria-label': 'set plan'}}
        />
      }
    />
  );
};
